import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { FileText, Calendar } from 'lucide-react';
import "../css/dashboard/chart.css";

const DocTypeStatsChart = ({ doc = [] }) => {
    const chartData = useMemo(() => {
    // 1. Group by the 'register_document' key
    const counts = doc.reduce((acc, item) => {
        // Normalize to lowercase for grouping, handle empty cases
        const type = item.register_document 
            ? item.register_document.toLowerCase().trim() 
            : 'other';
            
        acc[type] = (acc[type] || 0) + 1;
        return acc;
    }, {});

    // 2. Format for Recharts, convert to UPPERCASE, and sort
    return Object.keys(counts)
        .map(name => ({ 
            name: name.toLocaleUpperCase(), // Display as "SALE DEED" or "MORTGAGE"
            value: counts[name] 
        }))
        .sort((a, b) => b.value - a.value);
}, [doc]);

    const totalFiles = chartData.reduce((sum, item) => sum + item.value, 0);
    
    // Professional color palette for various document types
    const COLORS = ['#3b82f6', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444', '#06b6d4'];

    return (
        <div className="admin-chart-card">
            <div className="chart-header">
                <div className="title-area">
                    <div className="title-with-icon">
                        <FileText size={18} style={{ color: '#3b82f6' }} />
                        <h3 className="chart-title">Document Type Distribution</h3>
                    </div>
                    <span className="time-badge">
                        <Calendar size={12} /> Total Docs: {totalFiles}
                    </span>
                </div>
            </div>

            <div className="chart-wrapper" style={{ position: 'relative', height: '350px' }}>
                {/* Center Label showing Total Count */}
                <div style={{
                    position: 'absolute',
                    top: '44%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    pointerEvents: 'none'
                }}>
                    <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b' }}>{totalFiles}</span>
                    <p style={{ fontSize: '12px', color: '#64748b', margin: 0 }}>Documents</p>
                </div>

                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={80}
                            outerRadius={105}
                            paddingAngle={5}
                            dataKey="value"
                            stroke="none"
                            animationDuration={1200}
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip 
                            contentStyle={{ 
                                borderRadius: '10px', 
                                border: 'none', 
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)' 
                            }}
                        />
                        <Legend 
                            verticalAlign="bottom" 
                            align="center" 
                            iconType="circle" 
                            wrapperStyle={{ paddingTop: '20px' }}
                            formatter={(value) => <span style={{ color: '#475569', fontSize: '12px' }}>{value}</span>}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default DocTypeStatsChart;